import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SearchBoxModule } from "src/app/search-box/search-box.module";
import { ReturnSearchComponent } from "./return-search/return-search.component";


@NgModule({
  declarations: [ReturnSearchComponent],
  imports: [CommonModule, SearchBoxModule],
  exports: [ReturnSearchComponent],
})
export class ReturnSearchModule {}
